import { authFetch } from '@monorepo/utils/auth-fetch'
import { useEffect, useState } from 'react'
import { GET } from '../../constants'
import { createUrl } from '../../methods'

export const useVoices = (language?: string) => {
  const [voices, setVoices] = useState<
    {
      id: string
      name: string
      language: string
      provider: 'elevenlabs' | 'google'
      gender: string
      tier: 'standard' | 'premium' | 'superior' | 'exquisite'
      uri: string
      accent?: string
    }[]
  >([])
  useEffect(() => {
    authFetch(createUrl(GET.VOICES.ALL))
      .then(response => response.json())
      .then(voices => setVoices(voices.filter((voice: any) => !language || voice.language === language)))
      .catch(console.error)
  }, [language])
  return voices
}
